module.exports = __webpack_public_path__ + "d17106c8e59e762dbee596acae88abfa.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/bubble.png
 ** module id = 1561
 ** module chunks = 0
 **/